import { Formattable } from 'visuris/Data/Entities/Formattable';
import { LengthUnit } from 'visuris/Helpers/Enums';
import { formatDate, formatSpeed, formatLengthAsMeter } from 'visuris/Data/Formatters';
import * as i18n from 'CMS/core/i18n';

export default class Hull extends Formattable {

    public flaRefId: number = null;
    public name: string = null;
    public callSign: string = null;
    public mmsi: string = null;
    public imo: string = null;
    public eni: string = null;
    public hin: string = null;
    public atis: string = null;
    public tonnageCertificateNumber: string = null;
    public matchID: string = null;
    public synchronizedOn: Date = null;
    public maritime: boolean = null;
    public bowThruster: boolean = null;
    public fixedPitchPropeller: boolean = null;
    public doubleHull: boolean = null;
    public width: number = null;
    public length: number = null;
    public grossRegisterTon: number = null;
    public maximumSpeed: number = null;
    public maximumDraught: number = null;
    public maximumHeight: number = null;
    public deadweight: number = null;
    public cellphone: string = null;
    public email: string = null;
    public country: string = null;
    public hullType: string = null;
    public ownerName: string = null;
    public ownerDateOfBirth: Date = null;
    public ownerTelephone: string = null;
    public ownerCellphone: string = null;
    public ownerFax: string = null;
    public ownerEmail: string = null;
    public ownerVAT: string = null;
    public ownerBIC: string = null;
    public ownerIBAN: string = null;
    public ownerPaymentMethod: number = null;
    public tonnageCertificateIssueDate: Date = null;
    public tonnageCertificateValidFrom: Date = null;
    public tonnageCertificateValidTo: Date = null;
    public hullTypeMessage: string = null;
    public linkID: string = null;
    public privacyClass: number = null;
    public owned: boolean = null;

    constructor() {
        super();
    }

    protected getFormatters(): any {
        return {
            "synchronizedOn": () => { return formatDate(this.synchronizedOn); },
            "maritimeMessage": () => { return this.maritime == null ? "" : this.maritime ? i18n.getMessage("general.yes") : i18n.getMessage("general.no"); },
            "ownerDateOfBirth": () => { return formatDate(this.ownerDateOfBirth); },
            "tonnageCertificateIssueDate": () => { return formatDate(this.tonnageCertificateIssueDate); },
            "tonnageCertificateValidFrom": () => { return formatDate(this.tonnageCertificateValidFrom); },
            "tonnageCertificateValidTo": () => { return formatDate(this.tonnageCertificateValidTo); },
            "isOwnedByUser": () => { return this.owned; },
            "width": () => {
                return formatLengthAsMeter(this.width, LengthUnit.Centimeter);
            },
            "length": () => {
                return formatLengthAsMeter(this.length, LengthUnit.Centimeter);
            },
            "maximumDraught": () => {
                return formatLengthAsMeter(this.maximumDraught, LengthUnit.Centimeter);
            },
            "maximumHeight": () => {
                return formatLengthAsMeter(this.maximumHeight, LengthUnit.Centimeter);
            },
            "maximumSpeed":() => {
                return formatSpeed(this.maximumSpeed);
            }
        };
    }

}